import React, { useState, useEffect, lazy, Suspense } from 'react';

// TASK-157: el banner (framer-motion + iconos) se descarga recién cuando hay una versión nueva
const PWAUpdateBanner = lazy(() => import('./PWAUpdateBanner'));

/**
 * 🚀 PWAUpdatePrompt — Banner no invasivo que detecta nuevas versiones del Service Worker
 * y permite refrescar la aplicación al instante con skipWaiting.
 * TASK-157: este componente solo detecta la actualización; es liviano y va en el bundle inicial.
 */
const PWAUpdatePrompt = () => {
    const [waitingWorker, setWaitingWorker] = useState(null);
    const [showPrompt, setShowPrompt] = useState(false);

    useEffect(() => {
        if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

        // Detectar si el Service Worker encontró una actualización
        const handleServiceWorkerUpdate = (registration) => {
            if (registration.waiting) {
                setWaitingWorker(registration.waiting);
                setShowPrompt(true);
            }

            registration.addEventListener('updatefound', () => {
                const newWorker = registration.installing;
                if (!newWorker) return;

                newWorker.addEventListener('statechange', () => {
                    if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                        setWaitingWorker(newWorker);
                        setShowPrompt(true);
                    }
                });
            });
        };

        navigator.serviceWorker.getRegistration().then((reg) => {
            if (reg) handleServiceWorkerUpdate(reg);
        });

        // Escuchar cuando el nuevo Service Worker toma el control
        let refreshing = false;
        const handleControllerChange = () => {
            if (!refreshing) {
                refreshing = true;
                window.location.reload();
            }
        };

        navigator.serviceWorker?.addEventListener('controllerchange', handleControllerChange);

        return () => {
            navigator.serviceWorker?.removeEventListener('controllerchange', handleControllerChange);
        };
    }, []);

    const handleUpdate = () => {
        if (waitingWorker) {
            waitingWorker.postMessage({ type: 'SKIP_WAITING' });
        } else {
            window.location.reload();
        }
        setShowPrompt(false);
    };

    if (!showPrompt) return null;

    return (
        <Suspense fallback={null}>
            <PWAUpdateBanner onUpdate={handleUpdate} onClose={() => setShowPrompt(false)} />
        </Suspense>
    );
};

export default PWAUpdatePrompt;
